// API 基础配置
export const API_CONFIG = {
  baseURL: process.env.VUE_APP_API_BASE_URL || 'https://jb.tlshc.cn',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
}

// API 端点配置
export const API_ENDPOINTS = {
  // 认证相关
  AUTH: {
    ADMIN_LOGIN: '/api/auth.html?action=admin_login',
    AGENT_LOGIN: '/api/auth.html?action=agent_login',
    USER_LOGIN: '/api/auth.html?action=user_login',
    INVITE_REGISTER: '/api/auth.html?action=invite_register',
    USER_INFO: '/api/auth.html?action=user_info',
    LOGOUT: '/api/auth.html?action=logout'
  },

  // 卡密相关
  CARDS: {
    ACTIVATE: '/api/cards.html?action=activate',
    CHECK: '/api/cards.html?action=check',
    GENERATE: '/api/cards.html?action=generate',
    LIST: '/api/cards.html?action=list',
    DELETE: '/api/cards.html?action=delete',
  EXTEND: '/api/cards.html?action=extend',
  ASSIGN: '/api/cards.html?action=assign'
  },

  // 代理相关
  AGENTS: {
    LIST: '/api/agents.html?action=list',
    CREATE: '/api/agents.html?action=create',
    UPDATE: '/api/agents.html?action=update',
    DELETE: '/api/agents.html?action=delete',
    MY_CARDS: '/api/agents.html?action=my_cards'
  },

  // 统计相关
  STATS: {
    DASHBOARD: '/api/stats.html?action=dashboard',
    RECENT_ACTIVITIES: '/api/stats.html?action=recent_activities'
  },

  // 卡密类型相关
  CARD_TYPES: {
    LIST: '/api/card-types.html?action=list',
    CREATE: '/api/card-types.html?action=create',
    UPDATE: '/api/card-types.html?action=update',
    DELETE: '/api/card-types.html?action=delete',
    TOGGLE_STATUS: '/api/card-types.html?action=toggle_status'
  },

  // 日志相关
  LOGS: {
  // 对应后端 backend/api/logs.html
  LIST: '/api/logs.html?action=list',
  EXPORT: '/api/logs.html?action=export',
  STATS: '/api/logs.html?action=stats'
  },

  // 系统日志相关
  SYSTEM_LOGS: {
  // 对应后端 backend/api/system-logs.html
  LIST: '/api/system-logs.html?action=list',
  EXPORT: '/api/system-logs.html?action=export',
  STATS: '/api/system-logs.html?action=stats',
  CLEAR: '/api/system-logs.html?action=clear',
  LOGIN_LOGS: '/api/system-logs.html?action=login_logs'
  },

  // 设备管理相关
  DEVICE_MANAGEMENT: {
    LIST: '/api/device-management.html?action=list',
    DETAIL: '/api/device-management.html?action=detail',
    UNBIND: '/api/device-management.html?action=unbind',
  STATS: '/api/device-management.html?action=stats',
  UPDATE_REMARK: '/api/device-management.html?action=update_remark'
  },

  // APP管理相关
  APP_MANAGEMENT: {
    LIST: '/api/app-management.html?action=list',
    CREATE: '/api/app-management.html?action=create',
    UPDATE: '/api/app-management.html?action=update',
    DELETE: '/api/app-management.html?action=delete',
    TOGGLE_STATUS: '/api/app-management.html?action=toggle_status',
    USERS: '/api/app-management.html?action=users',
    DEVICES: '/api/app-management.html?action=devices',
    STATS: '/api/app-management.html?action=stats'
  },

  // 用户相关
  USER: {
    STATS: '/api/user.html?action=stats',
    CARDS: '/api/user.html?action=cards',
    DEVICES: '/api/user.html?action=devices',
    GAME_RECORDS: '/api/user.html?action=game_records',
    BALANCE_LOGS: '/api/user.html?action=balance_logs',
    COIN_LOGS: '/api/user.html?action=coin_logs',
    RECHARGE: '/api/user.html?action=recharge',
    ACTIVATE_CARD: '/api/user.html?action=activate_card',
    APP_STATS: '/api/user.html?action=app_stats',
    COIN_RECORDS: '/api/user.html?action=coin_records',
    APPS: '/api/user.html?action=apps',
    DEVICE_APP_STATS: '/api/user.html?action=device_app_stats'
  },
  USER_DEVICE: {
    UPDATE_REMARK: '/api/user.html?action=update_device_remark'
  },

  // 教程相关
  TUTORIALS: {
  LIST: '/api/tutorials.html?action=list',
  DETAIL: '/api/tutorials.html?action=detail',
  CREATE: '/api/tutorials.html?action=create',
  UPDATE: '/api/tutorials.html?action=update',
  DELETE: '/api/tutorials.html?action=delete',
  PUBLISH: '/api/tutorials.html?action=publish',
  UNPUBLISH: '/api/tutorials.html?action=unpublish',
  PIN: '/api/tutorials.html?action=pin',
  UNPIN: '/api/tutorials.html?action=unpin',
  BATCH_PIN: '/api/tutorials.html?action=batch_pin',
  UPDATE_ORDER: '/api/tutorials.html?action=update_order',
  UPLOAD_IMAGE: '/api/tutorials.html?action=upload_image',
  CATEGORIES: '/api/tutorials.html?action=categories'
  }
  ,TUTORIAL_CATEGORIES: {
    LIST: '/api/tutorial_categories.html?action=list',
    ALL: '/api/tutorial_categories.html?action=all',
    CREATE: '/api/tutorial_categories.html?action=create',
    UPDATE: '/api/tutorial_categories.html?action=update',
    DELETE: '/api/tutorial_categories.html?action=delete',
    TOGGLE: '/api/tutorial_categories.html?action=toggle_status'
  }
}

// HTTP 状态码
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
}
